import React, { forwardRef } from 'react'
import { hasJsonStructure } from 'helpers'

import useGetSetting from 'js/page/Widget/hooks/useGetSetting'
import WidgetType from 'js/page/Widget/types/WidgetType'

import CreateContentEdit from './CreateContentEdit/CreateContentEdit'
import CreateContentView from './CreateContentView/CreateContentView'

const CreateContent = forwardRef(
    (
        { guid, site, group, entity, isEditing, onSave, editMode }: WidgetType,
        ref,
    ) => {
        const getSetting = useGetSetting(entity)

        const settings = {
            layout: getSetting('layout', 'button'),
            subtype: getSetting('subtype', ''),
            title: getSetting('title'),
            description: getSetting('description'),
            groupGuid: group?.guid || getSetting('groupGuid'),
            buttonSize: getSetting('buttonSize', 'md'),
            buttonAlignment: getSetting('buttonAlignment', 'left'),
            categoryTags: hasJsonStructure(getSetting('categoryTags'))
                ? JSON.parse(getSetting('categoryTags'))
                : [],
            tags: getSetting('tags') ? getSetting('tags').split(',') : [],
        }

        if (isEditing) {
            return (
                <CreateContentEdit
                    ref={ref}
                    guid={guid}
                    widgetGroup={group}
                    site={site}
                    settings={settings}
                    onSave={onSave}
                />
            )
        }

        return (
            <CreateContentView
                guid={guid}
                settings={settings}
                editMode={editMode}
            />
        )
    },
)

CreateContent.displayName = 'CreateContent'

export default CreateContent
